import { ECHARTSCOLOR } from '@intelligence/utils/echartsConst';

/**
 * 横向柱状图颜色序列
 */
export const HORIZONTAL_BAR_CHART_COLORS = ECHARTSCOLOR;

/**
 * 柱子高度（null表示自适应）
 * 注：ECharts 横向柱状图仍使用 barWidth 控制柱子粗细
 */
export const HORIZONTAL_BAR_WIDTH = null;

/**
 * 柱子最大高度
 */
export const HORIZONTAL_BAR_MAX_WIDTH = 30;

/**
 * 柱子最小高度
 */
export const HORIZONTAL_BAR_MIN_WIDTH = 8;

/**
 * 高亮背景色
 */
export const HIGHLIGHT_BG_COLOR = 'rgba(50, 111, 240, 0.08)';

/**
 * 网格配置（带右侧标签）
 */
export const HORIZONTAL_BAR_GRID_WITH_LABEL = {
  left: 0,
  right: '60px',
  top: '10px',
  bottom: '20px',
  containLabel: true,
};

/**
 * 网格配置（无右侧标签）
 */
export const HORIZONTAL_BAR_GRID_WITHOUT_LABEL = {
  left: 0,
  right: '20px',
  top: '10px',
  bottom: '20px',
  containLabel: true,
};

/**
 * echarts横向柱状图静态配置
 */
export const HORIZONTAL_BAR_CHART_STATIC_OPTION: any = {
  color: HORIZONTAL_BAR_CHART_COLORS,
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'axis',
    padding: 0,
    borderWidth: 0,
    backgroundColor: 'rgba(255, 255, 255, 0)',
    confine: true,
    hideDelay: 200,
    triggerOn: 'mousemove',
    axisPointer: {
      type: 'shadow',
    },
  },
  legend: {
    show: false,
  },
  grid: HORIZONTAL_BAR_GRID_WITH_LABEL,
  xAxis: {
    type: 'value',
    splitNumber: 5,
    minInterval: 'auto',
    axisLabel: {
      color: '#838697',
      fontSize: 12,
    },
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: '#E5E5E5',
      },
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  yAxis: {
    type: 'category',
    axisTick: {
      show: false,
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      color: '#000',
      opacity: 0.45,
      fontSize: 12,
      margin: 8,
    },
    data: [],
  },
  series: [],
};
